import React, { useState, useEffect } from 'react';
import styles from "./generalStyles.module.css";

function WeekDayPick ({isReset,selectedDays}){
    const [weekSelection,setWeekSelection]=useState([
        {day:"Mon",status:true},
        {day:"Tue",status:true},
        {day:"Wed",status:true},
        {day:"Thu",status:true},
        {day:"Fri",status:true},
        {day:"Sat",status:true},
        {day:"Sun",status:true},
    ]);

    const getActiveSelection=(dayName)=>{
        const idx= weekSelection.findIndex((obj => obj.day === dayName));
        const currentStatus= weekSelection.filter((obj => obj.day === dayName))[0].status;
        let tmp=[...weekSelection];
        tmp[idx].status=!currentStatus;
        setWeekSelection(tmp);
    }
    useEffect(()=>{
        if(isReset){
            onResetWeekDay();
        }
    },[isReset])

    const onResetWeekDay=()=>{
        setWeekSelection([
            {day:"Mon",status:true},
            {day:"Tue",status:true},
            {day:"Wed",status:true},
            {day:"Thr",status:true},
            {day:"Fri",status:true},
            {day:"Sat",status:true},
            {day:"Sun",status:true},
        ]);
    }

    useEffect(() => {
        selectedDays(weekSelection)
    },[weekSelection])

    return(
        <div className={styles.weekcontainer}>
            {weekSelection && weekSelection.map((d)=>(
                <div className={d.status ? styles.weekDays_active : styles.weekDays} key={d.day} onClick={()=>getActiveSelection(d.day)}>{d.day}</div>
            ))}
        </div>
    )
}

export default WeekDayPick;